import { Hit } from 'instantsearch.js/es/types'
import React, { useEffect } from 'react'
import { useInstantSearch } from 'react-instantsearch-hooks-web'
import { OfferAlgoliaSearchResult } from './offer'

export type StatusPropsValue = {
  isLoading: boolean
  nbResults: number
  results: Hit<OfferAlgoliaSearchResult>[]
}

export type StatusProps = {
  onChange: (status: StatusPropsValue) => void
}

const SearchStatus: React.FC<StatusProps> = ({ onChange }) => {
  const { status, results } = useInstantSearch()
  useEffect(() => {
    onChange({
      isLoading: status === 'stalled' || status === 'loading',
      nbResults: results.nbHits || 0,
      results: results.hits || [],
    })
  }, [status])
  return <div className="sr-only" />
}

export default SearchStatus
